"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomIconKey = exports.CustomerNotificationsOptions = void 0;
var CustomerNotificationsOptions;
(function (CustomerNotificationsOptions) {
    /**
     * replaces customerNotificaitonsPrefrencedEnabled = false
     */
    CustomerNotificationsOptions["NoNotificationOption"] = "NO_NOTIFICATION_OPTION";
    /**
     * replaces customerNotificationPreferencesEnabled = true
     * show the buttons "Email Me" and "Text Me" on the summary
     */
    CustomerNotificationsOptions["TextOrEmail"] = "TEXT_OR_EMAIL";
    /**
     * replaces optionalCustomerEmailFieldEnabled
     * show an optional email field
     */
    CustomerNotificationsOptions["OptionalEmail"] = "OPTIONAL_EMAIL";
    /**
     * replaces requiredCustomerEmailEnabled
     * show a required email field
     */
    CustomerNotificationsOptions["RequiredEmail"] = "REQUIRED_EMAIL";
})(CustomerNotificationsOptions = exports.CustomerNotificationsOptions || (exports.CustomerNotificationsOptions = {}));
// This enum values need to match with `icon_keys` from ServiceCode (scheduling-service)
var RoomIconKey;
(function (RoomIconKey) {
    RoomIconKey["AIR_QUALITY"] = "air_quality";
    RoomIconKey["DEHUMIDIFIER"] = "dehumidifier";
    RoomIconKey["EMERGENCY_CARBON_MONOXIDE"] = "emergency_carbon_monoxide";
    RoomIconKey["EMERGENCY_ELECTRICITY"] = "emergency_electricity";
    RoomIconKey["EMERGENCY_ELECTRICITY_LARGE"] = "emergency_electricity_large";
    RoomIconKey["EMERGENCY_HVAC"] = "emergency_hvac";
    RoomIconKey["EMERGENCY_HVAC_LARGE"] = "emergency_hvac_large";
    RoomIconKey["EMERGENCY_LEAK"] = "emergency_leak";
    RoomIconKey["EXHAUST_FAN"] = "exhaust_fan";
    RoomIconKey["FLOOD"] = "flood";
    RoomIconKey["FLOOD_LARGE"] = "flood_large";
    RoomIconKey["FROZEN_PIPE"] = "frozen_pipe";
    RoomIconKey["FURNACE"] = "furnace";
    RoomIconKey["FURNACE_LARGE"] = "furnace_large";
    RoomIconKey["GAS_LEAK"] = "gas_leak";
    RoomIconKey["GENERATOR"] = "generator";
    RoomIconKey["GRINDER"] = "grinder";
    RoomIconKey["HUMIDIFIER"] = "humidifier";
    RoomIconKey["HVAC_UNIT"] = "hvac_unit";
    RoomIconKey["HVAC_UNIT_ATTIC"] = "hvac_unit_attic";
    RoomIconKey["HW_HEATER"] = "hw_heater";
    RoomIconKey["LIGHT_CHANDELIER"] = "light_chandelier";
    RoomIconKey["LIGHT_EXTERIOR"] = "light_exterior";
    RoomIconKey["LIGHT_PENDANT"] = "light_pendant";
    RoomIconKey["LIGHT_SIMPLE"] = "light_simple";
    RoomIconKey["LIGHT_SWITCH"] = "light_switch";
    RoomIconKey["LIGHT_SWITCH_LARGE"] = "light_switch_large";
    RoomIconKey["LOW_OR_NO_WATER"] = "low_or_no_water";
    RoomIconKey["NOISE"] = "noise";
    RoomIconKey["NO_HOT_WATER"] = "no_hot_water";
    RoomIconKey["OUTLET"] = "outlet";
    RoomIconKey["OUTLET_LARGE"] = "outlet_large";
    RoomIconKey["PANEL"] = "panel";
    RoomIconKey["PLUMBING_LEAK"] = "plumbing_leak";
    RoomIconKey["REGISTER"] = "register";
    RoomIconKey["REGISTER_LARGE"] = "register_large";
    RoomIconKey["SHOWER"] = "shower";
    RoomIconKey["SINK_BATHROOM"] = "sink_bathroom";
    RoomIconKey["SINK_KITCHEN"] = "sink_kitchen";
    RoomIconKey["SINK_KITCHEN_DISPOSAL"] = "sink_kitchen_disposal";
    RoomIconKey["SINK_KITCHEN_LARGE"] = "sink_kitchen_large";
    RoomIconKey["SINK_UTILITY"] = "sink_utility";
    RoomIconKey["SMELL"] = "smell";
    RoomIconKey["SOLAR"] = "solar";
    RoomIconKey["SPIGOT"] = "spigot";
    RoomIconKey["SUMP_PUMP"] = "sump_pump";
    RoomIconKey["THERMOSTAT"] = "thermostat";
    RoomIconKey["THERMOSTAT_LARGE"] = "thermostat_large";
    RoomIconKey["TOILET"] = "toilet";
    RoomIconKey["TRADE_ELECTRICAL"] = "trade_electrical";
    RoomIconKey["TRADE_HVAC"] = "trade_hvac";
    RoomIconKey["TRADE_OTHER"] = "trade_other";
    RoomIconKey["TRADE_PLUMBING"] = "trade_plumbing";
    RoomIconKey["UV_LIGHT"] = "uv_light";
    RoomIconKey["WATER_TREATMENT"] = "water_treatment";
    RoomIconKey["WELL_PUMP"] = "well_pump";
})(RoomIconKey = exports.RoomIconKey || (exports.RoomIconKey = {}));
